/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import Page from 'components/custom/template/Page';
import React, { useRef } from 'react';
import useShowModal from 'hooks/custom/useShowModal';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import useHandleChangeStatus from 'hooks/custom/useHandleChangeStatus';
import useHandleDelete from 'hooks/custom/useHandleDelete';
// import apiEndpoints from 'api/endpoints';
import departmentListColumn from './departmentListColumn';
import CreateDepartment from '../../../views/setting/Department/CreateDepartment';
import EditDepartment from '../../../views/setting/Department/EditDepartment';
import apiEndpoints from 'constants/apiEndpoints';
import { useAuth } from 'hooks/auth/useAuth';

export default function Department() {
  const [pageLoading, loadingMessage, handleLoading] = useManagePageLoading();
  const createModal = useShowModal();
  const editDepartment = useShowModal();
  const refreshDataRef = useRef(null);
  const departmentStatusChange = useHandleChangeStatus();
  const departmentDelete = useHandleDelete();
  const { abilities } = useAuth();

  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };

  const handleRefresh = () => {
    if (refreshDataRef.current) {
      refreshDataRef.current();
    }
  };

  const handleChangeStatus = async department => {
    departmentStatusChange({
      label: 'department',
      name: department.department_name,
      status: department.status,
      url:
        department.status === 'Active'
          ? apiEndpoints.department.approvalInactive
          : apiEndpoints.department.approvalActive,
      handleLoading,
      handleRefresh,
      payLoad: {
        status: department.status === 'Active' ? 'In-active' : 'Active',
        department_id: department.department_id
      }
    });
  };

  const handleDeleteDepartment = async department => {
    departmentDelete({
      label: 'Department',
      name: department.department_name,
      // url: 'department_status',
      url: apiEndpoints.department.delete,
      handleLoading,
      handleRefresh,
      payLoad: {
        // department_status: 'Deleted',
        department_id: department.department_id
      }
    });
  };

  const actions = original => ({
    view: {
      label: 'View',
      action: () => editDepartment.handleOpenModal(original)
    },
    edit: {
      label: 'Edit',
      disabled: !abilities.can('edit', 'Department'),
      action: () =>
        editDepartment.handleOpenModal({ ...original, isEditable: true })
    },

    actionStatus: {
      label: original.department_status === 'Active' ? 'In-active' : 'Active',
      disabled: !abilities.can('edit', 'Department'),
      icon:
        original.department_status === 'Active'
          ? 'mdi:block'
          : 'heroicons-outline:check',
      className:
        original.department_status === 'Active'
          ? 'text-danger'
          : 'text-success',
      action: () => handleChangeStatus(original)
    },
    actionDelete: {
      label: 'Delete',
      disabled: !abilities.can('delete', 'Department'),
      action: () => handleDeleteDepartment(original)
    }
  });
  return (
    <Page
      title={'Department'}
      tableColumn={{ column: departmentListColumn, actions }}
      urlEndPoint={apiEndpoints.department.getAll}
      exportName="Department list"
      backdrop={{ message: loadingMessage, loading: pageLoading }}
      addNew={createModal.handleOpenModal}
      addBtnText="Add Department"
      onRegisterRefresh={handleRefreshDataRegister}
      createPermission={{ moduleName: 'Department' }}
    >
      {createModal.isOpen && (
        <CreateDepartment
          show={createModal.isOpen}
          handleClose={createModal.handleCloseModal}
          handleRefresh={handleRefresh}
        />
      )}

      {editDepartment.isOpen && (
        <EditDepartment
          show={editDepartment.isOpen}
          handleClose={editDepartment.handleCloseModal}
          handleRefresh={handleRefresh}
          data={editDepartment.modalData}
          actions={actions}
        />
      )}
    </Page>
  );
}
